import { z } from 'zod';
import { AnimaAPI } from './api';
import { raiseIfResponseError } from './errors';
import { User } from './types';

export type AnimaUserParams = {
  animaAPI: AnimaAPI;
};

export class AnimaUser {
  constructor(private readonly params: AnimaUserParams) {}

  async me(): Promise<User | null> {
    const response = await this.params.animaAPI.fetchAPI(`/users/me`, {
      method: 'GET',
    });

    if (response.status === 401) {
      return null;
    }
    await raiseIfResponseError(response);

    const json = await response.json();
    const parsedUser = userSchema.parse(json);

    return {
      id: parsedUser.id,
      email: parsedUser.email,
      name: parsedUser.name,
      role: parsedUser.role,
      profilePictureUrl: parsedUser.profilePictureUrl ?? undefined,
    };
  }
}

const userSchema = z.object({
  id: z.string(),
  email: z.string(),
  name: z.string(),
  role: z.enum(['admin', 'user']),
  profilePictureUrl: z.string().url().nullish(),
});
